import React, {Component} from "react";
import SmartDialog from "../components/SmartDialog";

export default class PlaceHolderDialog extends Component{

    constructor(props){
        super(props);
        this.state = {
            title: null,
            showCancelButton: false,
            onShow: null,
            onExit: null,
            content: null,
            large: false
        };

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    hide(){
        this._dlg.hide();
    }

    /**
     * Shows smart dialog with properties specified
     * @param title
     * @param showCancelButton
     * @param onShow
     * @param onExit
     * @param content
     * @param large
     */
    show({ title  , showCancelButton , onShow , onExit ,  content , large }){

        this.setState({
            title,
            showCancelButton,
            onShow,
            onExit,
            content,
            large
        }, () => this._dlg.show());

    }

    render(){

        const { title , showCancelButton , onShow , onExit , content , large } = this.state;

        return <SmartDialog ref={r => this._dlg = r}
                            title={title}
                            showCancelButton={showCancelButton}
                            onShow={onShow}
                            large={large}
                            onExit={onExit}>
            {content}
        </SmartDialog>

    }

}



// WEBPACK FOOTER //
// ./src/common/PlaceHolderDialog.js